
import { useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import Highlights from '../Component/Highlights'
import LazyLoad from 'react-lazyload';
import Search from './Search';
const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <div className="header">
        {/* <div className="logo">
          <NavLink to="/">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/logo.jpg" alt="Mata Mariyam Jan Sewa" className="img-fluid" /></LazyLoad>
          </NavLink>
        </div> */}
        <div className="logo">
          <div class="logo-area">
            <div class="logo-wrapper">
              <div class="logo-img-circle">
                <NavLink to="/">
                  <LazyLoad>
                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/logo.gif" alt="Mata Mariyam Jan Sewa" className="img-fluid" />
                  </LazyLoad>
                </NavLink>
              </div>
              <NavLink to="/">
                <div class="logo-text">
                  <h1 class="logo-title">Mata Mariam Jan Seva </h1>
                  <p class="logo-title">Vidyalaya</p>
                </div>
              </NavLink>
            </div>
          </div>
        </div>
        <div className="header-nav">
          <Highlights />
          {/* 
          <div className='header-list'>
            <div className='search_box'>
              <input type="search" placeholder='Search' />
              <i className="bi bi-search"></i>
            </div>
            <button className='yellow-btn'><NavLink to="/CBSE-disclosure">Mandatory Disclosure</NavLink></button>
            <button className='yellow-btn'><NavLink to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/Terms-Conditions.pdf" target="_blank" >Terms & Condition</NavLink></button>
            <button className='red-btn'><NavLink to="/Magazine">Magazines</NavLink></button>
          </div> */}
          <nav className="navbar navbar-expand-lg">
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="main_nav">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink className="dropdown-item" to="/">
                    <i className="bi bi-house-door-fill"></i>
                  </NavLink>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"> School</div>
                  <ul className="dropdown-menu fade-up">
                    <li><NavLink className="dropdown-item" to="/about">About Us</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/our-patron">Our Patron</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/aims-objectives">Aims And Objectives</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/prayers">Prayers</NavLink></li>
                    <li><NavLink className="dropdown-item" to="https://www.cbse.gov.in/" target='_blank'>CBSE Website</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Academic </NavLink></div>
                  <ul className="dropdown-menu fade-up">
                    <li><NavLink className="dropdown-item" to="/subject-examination">Subjects Of Examination </NavLink></li>
                    <li><NavLink className="dropdown-item" to="/syllabus">Syllabus</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/co-curricular">Co-Curricular Activities</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/examination-promotion">Examinations And Promotions</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/withdrawal">Procedure For Withdrawal</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/help-study">Helps to Study</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/Tc">TC</NavLink></li>
                    {/* <li><NavLink className="dropdown-item" to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/Book_list.pdf" target='_blank'>Book List</NavLink></li> */}
                    {/*<li><NavLink   className="dropdown-item" to="/Admission">Admission</NavLink></li>   */}
                  </ul>
                </li>

                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Admission </NavLink> </div>
                  <ul className="dropdown-menu fade-up">
                    <li><NavLink className="dropdown-item" to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/AdmissionGuidelines.pdf" target='_blank'>Admission Guidelines</NavLink></li>
                  </ul>
                </li>


                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/"> Disclosure</NavLink> </div>
                  <ul className="dropdown-menu fade-up">
                    <li><NavLink className="dropdown-item" to="/CBSE-disclosure">CBSE Mandatory Disclosure</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/campus-information">Campus Information</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/general-information">General Information</NavLink></li>
                    <li><NavLink className="dropdown-item" to="/school-information">School Information</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Rules </NavLink></div>
                  <ul className="dropdown-menu fade-up">
                    <li> <NavLink className="dropdown-item" to="/dicipline">Rules of Discipline </NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/payment-fee">Rules for Payment of Fee</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/admission-regulations">Admission Regulations</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/leave-rules">Leave Rules</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/uniform">School Uniform</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/library">School Library</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/school-hour">School Hours</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Office Bearers</NavLink></div>
                  <ul className="dropdown-menu fade-up">
                    <li> <NavLink className="dropdown-item" to="/managing-committee">Managing Committee</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/our-managers">Our Managers</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/our-principals">Our Principals</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/student-cabinets">Student Cabinets</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/school-staff">School Staff</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/school-management">School Management</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Messages</NavLink></div>
                  <ul className="dropdown-menu fade-up">
                    <li> <NavLink className="dropdown-item" to="/chairman">Chairman’s Message</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/manager">Manager’s Message</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/principal">Principal’s Message</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/headmistress">Headmistress’s Message</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/president-message">President’s Message</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown"><NavLink className="dropdown-item" to="/">Gallery</NavLink></div>
                  <ul className="dropdown-menu fade-up">
                    <li> <NavLink className="dropdown-item" to="/gallery">Photo Gallery</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/VideoGallery">Video Gallery</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/Magazine">Magazine</NavLink></li>
                    <li> <NavLink className="dropdown-item" to="/voice-message">Voice Message</NavLink></li>
                  </ul>
                </li>
                <li className="nav-item"><NavLink className="dropdown-item" to="/contact-us"> Contact Us </NavLink></li>

                <Search />
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  )
}

export default Header
